import React from 'react';
import { Row, Col } from "reactstrap";
import FormInput from '../../../../comum/components/FormInput';
import FormInputNumber from '../../../../comum/components/FormInputNumber';
import FormInputCurrency from '../../../../comum/components/FormInputCurrency';
import {inject, observer} from "mobx-react";
import { IconeDelete } from '../../../../comum/components/Icones';

@inject("store")
@observer
export default class CardNotaFiscalNCM extends React.Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controller = this.props.controller;
    }

    render() {
    	return (
			this.appStore.isMobile()
			? <Row>
                <FormInput titulo={ "NCM" } sm={12} md={12}
                    objeto={ this.props.este }
                    bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                    dado={ `NcmMerc` }
                    limiteMaximo={8}
                    onChange={ (event) => this.props.setDado(`${this.props.dado}.NcmMerc`, event) }  />
                <FormInputNumber titulo={ "Quantidade" } sm={12} md={12} 
                    objeto={ this.props.este }
                    bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                    dado={ `QtdItem` }
                    onChange={ (event) => this.props.setDado(`${this.props.dado}.QtdItem`, event) }  />
                <FormInputCurrency titulo={ "Valor Item" } sm={12} md={12} 
                    objeto={ this.props.este }
                    bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                    dado={ `ValItem` }
                    onChange={ (event) => this.props.setDado(`${this.props.dado}.ValItem`, event) }  />
                <FormInputCurrency titulo={ "Peso Item" } sm={12} md={12} 
                    objeto={ this.props.este }
                    bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                    dado={ `PesoItem` }
                    onChange={ (event) => this.props.setDado(`${this.props.dado}.PesoItem`, event) }  />
                <FormInput titulo={ "CFOP" } sm={12} md={12}
                    objeto={ this.props.este }
                    bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                    dado={ `CodCfop` }
                    onChange={ (event) => this.props.setDado(`${this.props.dado}.CodCfop`, event) }  />
                <a className="ml-3" onClick={() => this.props.removeNCM(this.props.index)}>Excluir</a>
            </Row>
            : <Row className="linha-completa">
                <Col className="card-form">
                    <Row className="w-100">
                        <FormInput sm={12} md={3}
                            objeto={ this.props.este }
                            bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                            dado={ `NcmMerc` }
                            limiteMaximo={8}
                            onChange={ (event) => this.props.setDado(`${this.props.dado}.NcmMerc`, event) } />
                        <FormInputNumber sm={12} md={2}
                            objeto={ this.props.este }
                            bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                            dado={ `QtdItem` }
                            onChange={ (event) => this.props.setDado(`${this.props.dado}.QtdItem`, event) } />
                        <FormInputCurrency sm={12} md={2}
                            objeto={ this.props.este }
                            bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                            dado={ `ValItem` }
                            onChange={ (event) => this.props.setDado(`${this.props.dado}.ValItem`, event) } />
                        <FormInputCurrency sm={12} md={2}
                            objeto={ this.props.este }
                            bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                            dado={ `PesoItem` }
                            onChange={ (event) => this.props.setDado(`${this.props.dado}.PesoItem`, event) } />
                        <FormInput sm={12} md={3}
                            objeto={ this.props.este }
                            bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : false}
                            dado={ `CodCfop` }
                            onChange={ (event) => this.props.setDado(`${this.props.dado}.CodCfop`, event) } />
                    </Row>
                    {this.props.somenteLeitura ? <div /> : 
                    <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.props.removeNCM(this.props.index) }/>}
                </Col>
            </Row>
        );
    }    
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/components/CardNotaFiscalNCM.js